import { useState, useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { Row, Col, Form } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import { PatternFormat } from 'react-number-format';
import {
  validateEmail,
  validateName,
  validatePhone,
  cleanDocument,
  pixelNative,
  pixelTikTok,
  googleAnalyticsSend,
} from 'functions.js';
import { cpf } from 'cpf-cnpj-validator';
import api from 'api';
import useQuery from 'query/queryHook';

export default function CheckoutUserData({
  offer,
  setCustomerDataSent,
  fbPixels,
  setFullName,
  uuidOffer,
  product,
  orderBumps,
  register,
  formState,
  setValue,
  getValues,
  control,
  setFocus,
  setError,
  clearErrors,
  googlePixels,
}) {
  const query = useQuery();
  const [resident, setResident] = useState('brasil');
  const [delivery, setDelivery] = useState(null);
  const [isObPhysical, setIsObPhysical] = useState(false);
  const { errors, isValid } = formState;

  const initiateCart = () => {
    if (getValues('full_name') === '') {
      return false;
    }
    if (getValues('email') === '') {
      return false;
    }
    if (getValues('document') === '' || !cpf.isValid(getValues('document'))) {
      return false;
    }
    if (getValues('whatsapp') === '') {
      return false;
    }

    let body = {
      full_name: getValues('full_name'),
      email: getValues('email'),
      document_number: cleanDocument(getValues('document')),
      whatsapp: getValues('whatsapp'),
      offer_uuid: uuidOffer,
      address: {
        zipcode: delivery?.cep,
        street: getValues('street'),
        number: getValues('number_address'),
        complement: getValues('complement'),
        neighborhood: getValues('neighborhood'),
        city: delivery?.localidade,
        state: delivery?.uf,
      },
      params: {},
    };

    if (query.get('src')) body['params']['src'] = query.get('src');
    if (query.get('sck')) body['params']['sck'] = query.get('sck');
    if (query.get('utm_source'))
      body['params']['utm_source'] = query.get('utm_source');
    if (query.get('utm_medium'))
      body['params']['utm_medium'] = query.get('utm_medium');
    if (query.get('utm_campaign'))
      body['params']['utm_campaign'] = query.get('utm_campaign');
    if (query.get('utm_content'))
      body['params']['utm_content'] = query.get('utm_content');
    if (query.get('utm_term'))
      body['params']['utm_term'] = query.get('utm_term');

    api
      .post('/cart/initiate', body)
      .then((r) => {
        if (r.data === 'OK') {
          if (product.type !== 'physical') {
            setCustomerDataSent(true);
          }
          setFullName(body.full_name);
          if (fbPixels.length > 0) {
            pixelNative('AddPaymentInfo', {
              value: offer.price,
              currency: 'BRL',
              content_ids: [offer.uuid],
              num_items: 1,
            });

            pixelTikTok('AddPaymentInfo');
          }
          if (googlePixels.length > 0) {
            googlePixels.forEach(() => {
              googleAnalyticsSend('add_payment_info', {
                currency: 'BRL',
                value: offer.price,
                items: [{ item_name: offer.product.name }],
              });
            });
          }
        }
      })
      .catch(() => {
        setCustomerDataSent(false);
      });
  };

  useEffect(() => {
    if (isValid) initiateCart();
  }, [isValid]);

  useEffect(() => {
    setFocus('full_name');
  }, []);

  const getDelivery = (cep) => {
    fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then((r) => r.json())
      .then((data) => {
        if (!data.erro) {
          setDelivery(data);
          setValue('street', data.logradouro);
          setValue('neighborhood', data.bairro);
          clearErrors('zipcode');
          if (googlePixels.length > 0) {
            googlePixels.forEach(() => {
              googleAnalyticsSend('add_shipping_info', {
                currency: 'BRL',
                value: offer.price,
                items: [{ item_name: offer.product.name }],
              });
            });
          }
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    const ObPhysical =
      orderBumps.filter(
        (item) => item.quantity > 0 && item.product.type === 'physical'
      ).length > 0;
    setIsObPhysical(ObPhysical);
    if (!ObPhysical) {
      clearErrors('zipcode');
    }

    if (product.type !== 'physical') {
      if (
        orderBumps.filter(
          (item) => item.quantity > 0 && item.product.type === 'physical'
        ).length > 0 &&
        !delivery
      ) {
        setError('zipcode');
        setCustomerDataSent(false);
      }
    }
  }, [orderBumps]);

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      setCustomerDataSent(false);
    } else {
      setCustomerDataSent(true);
    }
  });

  return (
    <div className='personal-info'>
      <Row g='1'>
        <Col xs={12}>
          <div className='d-flex residente'>
            <span>
              <input
                id='residenteBrasil'
                name='residente'
                type='radio'
                value='brasil'
                defaultChecked
                onChange={() => {
                  setResident('brasil');
                }}
              />
              <label htmlFor='residenteBrasil'>Resido no Brasil</label>
            </span>
            <span>
              <input
                id='residenteExterior'
                name='residente'
                type='radio'
                value='exterior'
                onChange={() => {
                  setResident('exterior');
                }}
              />
              <label htmlFor='residenteExterior'>Resido no exterior</label>
            </span>
          </div>
        </Col>
        <Col md={6}>
          <div className='input-group mb-3'>
            <div className='area'>
              <label htmlFor='full_name'>
                <i className='las la-user'></i>
              </label>
              <Form.Control
                {...register('full_name', {
                  required: true,
                  validate: (value) => validateName(value),
                })}
                autoComplete='off'
                className={errors.full_name ? 'is-invalid' : ''}
                id='full_name'
                placeholder='Digite seu nome completo'
                type='text'
                onBlur={initiateCart}
              />
              {errors.full_name && (
                <div className='input-error'>Informe seu nome completo</div>
              )}
            </div>
          </div>
        </Col>
        <Col md={6}>
          <div className='input-group mb-3'>
            <div className='area'>
              <label htmlFor='email'>
                <i className='las la-envelope'></i>
              </label>
              <Form.Control
                {...register('email', {
                  required: true,
                  validate: (value) => validateEmail(value),
                })}
                onBlur={initiateCart}
                id='email'
                autoComplete='off'
                placeholder='Digite seu e-mail'
                type='email'
                className={errors.email ? 'is-invalid' : ''}
              />
              {errors.email && (
                <div className='input-error'>E-mail inválido</div>
              )}
            </div>
          </div>
        </Col>
        <Col md={6}>
          <div className='input-group mb-3'>
            <div className='area'>
              <label htmlFor='cpf'>
                <i className='las la-address-card' />
              </label>
              <InputMask
                {...register('document', {
                  required: true,
                  validate: (value) => {
                    if (!value) return false;
                    let crop = value.substring(0, 14);
                    return cpf.isValid(crop);
                  },
                })}
                onBlur={initiateCart}
                autoComplete='off'
                id='cpf'
                type='tel'
                placeholder='CPF'
                mask='999.999.999-99'
                className={
                  errors.document ? 'form-control is-invalid' : 'form-control'
                }
              />
              {errors.document && (
                <div className='input-error'>CPF inválido</div>
              )}
            </div>
          </div>
        </Col>
        <Col md={6}>
          <div className='input-group mb-3'>
            <div className='area'>
              <label htmlFor='whatsapp'>
                <i className='la la-whatsapp'></i>
              </label>

              <Controller
                rules={{
                  required: true,
                  validate: (value) => {
                    return validatePhone(value, resident);
                  },
                }}
                render={({ field: { onChange } }) => (
                  <PatternFormat
                    id='whatsapp'
                    name='phone_number'
                    type='tel'
                    onValueChange={(values) => {
                      onChange(values.value);
                    }}
                    onBlur={initiateCart}
                    // allowEmptyFormatting
                    valueIsNumericString={true}
                    className={
                      errors.whatsapp
                        ? 'form-control is-invalid'
                        : 'form-control'
                    }
                    format={
                      resident === 'brasil'
                        ? '## ##### ####'
                        : '####################'
                    }
                    placeholder='WhatsApp'
                  />
                )}
                name='whatsapp'
                control={control}
                defaultValue=''
              />
              {errors.whatsapp && (
                <div className='input-error'>Telefone inválido</div>
              )}
            </div>
          </div>
        </Col>

        {(offer.require_address ||
          product.type === 'physical' ||
          isObPhysical) && (
          <>
            <Col md={6} className='mb-3'>
              <div className='input-group'>
                <div className='area'>
                  <label htmlFor='zipcode'>
                    <i className='las la-box'></i>
                  </label>
                  <Controller
                    name='zipcode'
                    control={control}
                    rules={{
                      required:
                        offer.require_address ||
                        product.type === 'physical' ||
                        isObPhysical,
                    }}
                    render={({ field }) => (
                      <PatternFormat
                        onBlur={initiateCart}
                        onValueChange={(values) => {
                          if (values.value.length === 8) {
                            getDelivery(values.value);
                          }
                          field.onChange(values.value);
                        }}
                        type='text'
                        placeholder='CEP'
                        format='#####-###'
                        valueIsNumericString={true}
                        className={
                          errors.cep
                            ? 'form-control is-invalid'
                            : 'form-control'
                        }
                      />
                    )}
                  />
                  {errors.zipcode && (
                    <div className='input-error'>
                      Por favor, digite um CEP válido
                    </div>
                  )}
                </div>
              </div>
            </Col>

            {delivery && (
              <>
                <Col md={6} className='d-flex mb-3'>
                  <div className='input-group'>
                    <div className='area'>
                      <label htmlFor='number'>
                        <i className='las la-map-marked'></i>
                      </label>
                      <input
                        type='text'
                        value={`${delivery.localidade}/${delivery.uf}`}
                        className='form-control'
                        disabled={true}
                      />
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className='input-group mb-3'>
                    <div className='area'>
                      <label htmlFor='street'>
                        <i className='las la-road'></i>
                      </label>
                      <input
                        {...register('street', {
                          minLength: 3,
                          message: 'Digite um endereço válido',
                          required: true,
                        })}
                        // onFocusOut={initiateCart}
                        onBlur={initiateCart}
                        id='street'
                        type='street'
                        placeholder='Endereço'
                        defaultValue={delivery?.logradouro}
                        className={
                          errors.street
                            ? 'form-control is-invalid'
                            : 'form-control'
                        }
                      />
                      <div className='input-error'>
                        {errors?.street && errors?.street?.message}
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className='input-group mb-3'>
                    <div className='area'>
                      <label htmlFor='number_address'>
                        <i className='las la-home'></i>
                      </label>
                      <input
                        {...register('number_address', {
                          required: 'Digite um número válido',
                        })}
                        onBlur={initiateCart}
                        id='number_address'
                        type='text'
                        placeholder='Número'
                        className={
                          errors.number_address
                            ? 'form-control is-invalid'
                            : 'form-control'
                        }
                      />
                      <div className='input-error'>
                        {errors?.number_address &&
                          errors?.number_address?.message}
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className='input-group mb-3'>
                    <div className='area'>
                      <label htmlFor='neighborhood'>
                        <i className='las la-city'></i>
                      </label>
                      <input
                        {...register('neighborhood', {
                          required: true,
                          minLength: 3,
                        })}
                        onBlur={initiateCart}
                        id='neighborhood'
                        type='neighborhood'
                        placeholder='Bairro'
                        defaultValue={delivery?.bairro}
                        className={
                          errors.neighborhood
                            ? 'form-control is-invalid'
                            : 'form-control'
                        }
                      />
                      <div className='input-error'>
                        {errors?.neighborhood && errors?.neighborhood?.message}
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className='input-group mb-3'>
                    <div className='area'>
                      <label htmlFor='complement'>
                        <i className='las la-street-view'></i>
                      </label>
                      <input
                        {...register('complement')}
                        onBlur={initiateCart}
                        id='complement'
                        type='text'
                        placeholder='Complemento'
                        className={
                          errors.complement
                            ? 'form-control is-invalid'
                            : 'form-control'
                        }
                      />
                      <div className='input-error'>
                        {errors?.complement && errors?.complement?.message}
                      </div>
                    </div>
                  </div>
                </Col>
              </>
            )}
          </>
        )}
      </Row>
    </div>
  );
}
